import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackAddShippingInfoParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackAddShippingInfo";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackAddShippingInfo = (
    parameters: PartialSpecific<TrackAddShippingInfoParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters: TrackAddShippingInfoParameters = {
        ...ga.use.eventListParameters(options),
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        promotions: ga.use.promotions(options),
        cart: ga.use.cart(options, true),
        ...options,
    };

    return (parameters: Partial<TrackAddShippingInfoParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.addShippingInfo({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackAddShippingInfo;
